export default __webpack_public_path__ + "8cd0f5bbcf4f2b2a3d76fc8693f0b417.png";